import { useMemo } from 'react';
import { useFieldArray } from 'react-final-form-arrays';

import { CheckboxWithRelatedFields } from '@stores/settingsStore/constants';
import type { PropertyWithType } from '@stores/settingsStore';

export type OutputValues = 'enableMail';

export const useValueByFieldArray = (): { [key in OutputValues]: boolean | string | undefined } => {
  const { fields } = useFieldArray<PropertyWithType>('properties');

  const enableMail = useMemo(
    () => fields.value?.find((el) => el.key === CheckboxWithRelatedFields.mail)?.value,
    [fields.value],
  );

  return { enableMail };
};
